<template>
  <q-page-container>
      <q-page padding v-show="!isLoading">
        <div class="q-gutter-y-lg">
          <div class="row">
            <div class="col-4 q-px-md">
              <embed-generator />
            </div>
            <div class="col q-px-sm" style="border-left: 1px solid LightGray; border-radius: 5px;">
              <embed-documentation />
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
</template>

<script>
import { reactive } from 'vue'
import { useQuasar } from 'quasar'
import embedGenerator from './EmbedGenerator.vue'
import embedDocumentation from './EmbedDocumentation.vue'

export default {
  name: 'dash-board',
  components: {
    embedGenerator,
    embedDocumentation
  },

  setup () {
    const state = reactive({
      isLoading: false
    })

    return state
  },

  logout () {
    this.$q = useQuasar()
    this.$q.notify('Logged out')
  }
}
</script>
